import React from 'react'
import mealsImage from '../../assets/meals.jpg'
import classes from './Header.module.css'
import HeaderCartButton from './HeaderCartButton'

function Header(props){
    return(
        <>
            <header className={classes.header}>
                <h1>Meal Master</h1>
                <HeaderCartButton onClick={props.onShowCart}/>
            </header>
            <div className={classes['main-image']}>
                <img src={mealsImage} alt='Food table'/>
            </div>
        </>
    )
}

export default Header